'use client';

import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { Topbar } from '@/components/layout';

const TAB_LABELS = ['All', 'Trades', 'Deposits', 'Withdrawals'];
const COLUMN_COUNT = 7;
const ROW_COUNT = 6;

export const ActivitySkeleton = () => (
  <Box>
    <Topbar title="Activity" subtitle="View your trading activity and history" />

    <Box
      sx={{
        display: 'flex',
        gap: 3,
        borderBottom: 1,
        borderColor: 'divider',
        mb: 3,
        minHeight: 48,
      }}
    >
      {TAB_LABELS.map((label) => (
        <Skeleton key={label} variant="text" width={label.length * 8 + 16} height={40} />
      ))}
    </Box>

    <Box sx={{ py: 3 }}>
      <Paper
        sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider', overflow: 'hidden' }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {Array.from({ length: COLUMN_COUNT }).map((_, i) => (
                <TableCell key={i}>
                  <Skeleton variant="text" width={i === 0 ? 100 : 60} height={20} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: ROW_COUNT }).map((_, row) => (
              <TableRow key={row}>
                {Array.from({ length: COLUMN_COUNT }).map((_, col) => (
                  <TableCell key={col}>
                    <Skeleton variant="text" width={col === 0 ? 100 : 60} height={20} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  </Box>
);
